const OptimizationGoalType = {
	MINIMUM: 'Minimum',
	MAXIMUM: 'Maximum'
};

export default OptimizationGoalType;
